module.exports = __webpack_public_path__ + "img/banner-1.991929dd.png";